<template>
    <div class="content">
          <iframe src="//sharecad.org/cadframe/load?url=https://drive.google.com/open?id=1yDZ6q6Xt4SozXrKxeJfCiKI0dYHSVTAr"
                  scrolling="no"
                  style="width: 1400px; height: 500px;">
           </iframe>
    </div>
</template>

<script>
    export default {
        name: "Report"
    }
</script>

<style scoped>

</style> 


// WEBPACK FOOTER //
// src/pages/Report.vue